import _ from 'lodash'

export default function ({Vue, store}) {

  Vue.prototype.$_
    = store.$_
    = _;
}
